import { createRouter, createWebHistory } from 'vue-router'
import { LoginCallback } from '@okta/okta-vue'
import { navigationGuard } from '@okta/okta-vue'

import DashboardView from '../components/pages/DashboardView.vue'
import FeedView from '../components/pages/FeedView.vue'
import ErrorView from '../components/pages/ErrorView.vue'
import PageNotFoundView from '../components/pages/PageNotFoundView.vue'
import LogoutView from '../components/pages/LogoutView.vue'
import InsightView from '../components/pages/InsightView.vue'
import MaintenanceView from '../components/pages/MaintenanceView.vue'
import SimulatorView from '../components/pages/SimulatorView.vue'
import UserGuide from '../components/pages/UserGuide.vue'
import CookieDetail from '../components/pages/CookieDetail.vue'
import FilterSet from '../components/pages/FilterSet.vue'
import AscendPage from '../components/pages/AscendPage.vue'

//const CALLBACK_PATH = '/internal/login'
const REQUIRE_AUTH = true

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/ascend', component: AscendPage, meta: { title: 'Ascend', requiresAuth: REQUIRE_AUTH } },
        { path: '/performance', component: DashboardView, meta: { title: 'Performance', requiresAuth: REQUIRE_AUTH } },
        { path: '/performance/highlights', component: FeedView, meta: { title: 'Highlights', requiresAuth: REQUIRE_AUTH } },
        { path: '/performance/:viewName', component: DashboardView, meta: { title: 'Performance', requiresAuth: REQUIRE_AUTH }, props: true },
        { path: '/performance/highlights/:code/:product', component: InsightView, meta: { title: 'Highlight', requiresAuth: REQUIRE_AUTH }, props: true },
        { path: '/simulator', component: SimulatorView, meta: { title: 'Simulator', requiresAuth: REQUIRE_AUTH } },
        { path: '/simulator/:filterID', component: SimulatorView, meta: { title: 'Simulator', requiresAuth: REQUIRE_AUTH }, props: true },
        { path: '/simulator/filters', component: FilterSet, meta: { title: 'Filter Set', requiresAuth: REQUIRE_AUTH } },
        { path: '/user-guide', component: UserGuide, meta: { title: 'User Guide', requiresAuth: REQUIRE_AUTH } },
        { path: '/cookie-detail', component: CookieDetail, meta: { title: 'Cookie Detail' } },
        { path: '/internal/login', component: LoginCallback, meta: { title: 'Logged in' } },
        { path: '/internal/logout', component: LogoutView, meta: { title: 'Logged out' } },
        { path: '/error', component: ErrorView, meta: { title: 'Error' } },
        { path: '/not-found', component: PageNotFoundView, meta: { title: 'Page not found' } },
        { path: '/maintenance', component: MaintenanceView, meta: { title: 'Maintenance' } },
        { path: '/', redirect: '/performance' },
        { path: '/*', redirect: '/not-found' }
    ]
})

router.beforeEach(navigationGuard)

router.afterEach(to => {
    if (document) {
        document.title = to.meta.title ? `${to.meta.title} | EligibilityIQ` : 'EligibilityIQ'
    }
})

export default router
